import { GAME_TYPES } from "@/common/consts";

export const mapUnscrambleResponseItems = (items) => {
	return items.map((item) => {
		const newItem = {
			word: item.word,
		};

		newItem.score = item.scores?.[0];
		newItem.mod = item.mod;
		newItem.has_definition = item.scores?.[item.scores.length - 1] === 1;

		return newItem;
	});
};

export const mapWordlistResponseItems = (
	items,
	definitionsArray,
	modArray,
	scoreArray
) => {
	return items.map((item, index) => {
		return {
			word: item,
			has_definition: definitionsArray[index] == 1,
			mod: modArray[index],
			score: scoreArray[index],
		};
	});
};

export const groupWordsPerTable = (array) => {
	return array.reduce((previousValue, newValue) => {
		previousValue[`${newValue.word_length}`] = newValue;
		return previousValue;
	}, {});
};

export const mergeOldAndNewWords = (
	oldWords,
	offset,
	gameType,
	data,
	orderBy
) => {
	const newData = {};

	Object.entries(data).forEach(([g, group]) => {
		const oldItems = oldWords[g]?._items?.slice?.(0, offset) || [];

		let newItems = {};
		if ([GAME_TYPES.WORDSLISTS].includes(gameType)) {
			newItems = mapWordlistResponseItems(
				group._items,
				group._has_definition,
				group._mod,
				group._scores
			);
		} else {
			newItems = mapUnscrambleResponseItems(group._items);
		}

		newData[g] = {};
		newData[g]._items = [...oldItems, ...newItems];

		newData[g]._meta = data[g]._meta || {};
		if (orderBy) newData[g]._meta.order_by = orderBy;
	});

	return newData;
};
